import { withAppCrashIfException } from 'epic';
import { fetchStaticFormFromAdvisoryResultEpic } from 'epic/advisory/basket/loadFormWithAdvisoryResult.epic';
import { combineEpics } from 'redux-observable';
import { staticScreenTabContentEpic } from 'state/workspaces/static/tabContent';

import { cloneStaticFormEpic } from './clone';
import { closeStaticFormEpic } from './close';
import { costsAndChargeEpic } from './cost-and-charge';
import { staticFormEnrichmentRequestedEpic } from './enrichment-requested';
import { fetchDefaultStaticFormEpic } from './fetch-default';
import { fetchStaticWorkspaceTabsEpic } from './fetch-tabs';
import { fetchStaticFormWhenQuoteRepriceWithLastQuoteEpic } from './fetch-when-quote-reprice-with-last-quote';
import { kidDocumentEpic } from './kid-documentation';
import { loadProductDescriptionEpic, navigateToStaticWorkspaceEpic } from './navigate-to-workspace';
import { productGovernanceAssessmentEpic } from './product-governance-assesment';
import { productGovernanceDocumentEpic } from './product-governance-document';
import { productSummaryEpic } from './product-summary';
import { quoteResultEpic } from './quote-result';
import { removeStaticQuote } from './remove-quote';
import {
  staticWorkspaceRepriceEpic,
  staticWorkspaceRfqReloadEpic,
  staticWorkspaceSharableQuoteLoadEpic,
} from './reprice';
import { requestProductCodesEpic } from './request-product-codes';
import { requestQuoteEpic } from './request-quote';
import { requestStreamingTradeEpic, requestTradeEpic } from './request-trade';
import { staticFormRollbackEpic } from './rollback';

export const staticFormEpic = () =>
  combineEpics(
    withAppCrashIfException('requestStreamingTradeEpic', requestStreamingTradeEpic()),
    withAppCrashIfException('cloneStaticFormEpic', cloneStaticFormEpic()), // OK
    withAppCrashIfException('closeStaticFormEpic', closeStaticFormEpic()), // OK
    withAppCrashIfException('static-costsAndChargeEpic', costsAndChargeEpic()), // OK
    withAppCrashIfException('fetchDefaultStaticFormEpic', fetchDefaultStaticFormEpic()), // OK
    withAppCrashIfException(
      'fetchStaticFormWhenQuoteRepriceWithLastQuoteEpic',
      fetchStaticFormWhenQuoteRepriceWithLastQuoteEpic(),
    ), // OK
    withAppCrashIfException('fetchStaticFormFromAdvisoryResultEpic', fetchStaticFormFromAdvisoryResultEpic()),
    withAppCrashIfException('fetchStaticWorkspaceTabsEpic', fetchStaticWorkspaceTabsEpic()), // OK
    withAppCrashIfException('static-kidDocumentEpic', kidDocumentEpic()), // OK
    withAppCrashIfException('navigateToStaticWorkspaceEpic', navigateToStaticWorkspaceEpic()), // should be a thunk ?
    withAppCrashIfException('static-productGovernanceAssessmentEpic', productGovernanceAssessmentEpic()), // OK
    withAppCrashIfException('static-productGovernanceDocumentEpic', productGovernanceDocumentEpic()), // OK
    withAppCrashIfException('productSummaryEpic', productSummaryEpic()), // OK
    withAppCrashIfException('static-quoteResultEpic', quoteResultEpic()), // OK
    withAppCrashIfException('removeStaticQuote', removeStaticQuote()), // OK
    withAppCrashIfException('static-requestQuoteEpic', requestQuoteEpic()), // OK
    withAppCrashIfException('static-requestTradeEpic', requestTradeEpic()), // OK
    withAppCrashIfException('staticFormEnrichmentRequestedEpic', staticFormEnrichmentRequestedEpic()), // OK
    withAppCrashIfException('staticFormRollbackEpic', staticFormRollbackEpic()), // OK
    withAppCrashIfException('staticScreenTabContentEpic', staticScreenTabContentEpic()), // OK
    withAppCrashIfException('staticWorkspaceRepriceEpic', staticWorkspaceRepriceEpic()),
    withAppCrashIfException('staticWorkspaceRfqReloadEpic', staticWorkspaceRfqReloadEpic()),
    withAppCrashIfException('staticWorkspaceSharableQuoteLoadEpic', staticWorkspaceSharableQuoteLoadEpic()),
    withAppCrashIfException('loadProductDescriptionEpic', loadProductDescriptionEpic()),
    withAppCrashIfException('requestProductCodesEpic', requestProductCodesEpic()),
  );
